
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 192 192"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{staticClass:"icon-fill",attrs:{"d":"M156 92h16l-16-16.12V28h-24v24l-27.06-28.65c-4.28-4.56-13.78-4.38-17.88 0L20 92h16v72a8 8 0 008 8h40v-48h24v48h38.12c4.42 0 9.88-4.58 9.88-9V92","stroke":"#333","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"4"}}),_c('path',{attrs:{"d":"M0 0h192v192H0z"}})])])
          )
        }
      }
    